import React, { useState, useEffect } from "react";
import {
  TextField,
  Autocomplete,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  OutlinedInput,
  Chip,
  Box,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const FilterDeliverySamplShuttle = ({
  allSender,
  allReceiver,
  allDriver,
  allSiteLocation,
  onFilter,
  setIsDrawerOpen,
  formDataPreviousSearch,
}) => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);

  const [filters, setFilters] = useState({
    sender: formDataPreviousSearch.sender ? formDataPreviousSearch.sender : [],
    senderText: "",
    receiver: formDataPreviousSearch.receiver ? formDataPreviousSearch.receiver : [],
    receiverText: "",
    driver: formDataPreviousSearch.driver ? formDataPreviousSearch.driver : [],
    driverText: "",
    sendLocation: formDataPreviousSearch.sendLocation ? formDataPreviousSearch.sendLocation : [],
    receiveLocation: formDataPreviousSearch.receiveLocation ? formDataPreviousSearch.receiveLocation : [],
    startDate: formDataPreviousSearch.startDate ? formDataPreviousSearch.startDate : date,
    endDate: formDataPreviousSearch.endDate ? formDataPreviousSearch.endDate : null,
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const hasValue =
      filters.sender.length > 0 ||
      filters.senderText.trim() !== "" ||
      filters.receiver.length > 0 ||
      filters.receiverText.trim() !== "" ||
      filters.driver.length > 0 ||
      filters.driverText.trim() !== "" ||
      filters.sendLocation.length > 0 ||
      filters.receiveLocation.length > 0 ||
      filters.startDate !== null ||
      filters.endDate !== null;

    setIsButtonDisabled(!hasValue);
  }, [filters]);

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    if (filters.sender.length > 0) {
      filters.senderText = ""
    }
    if (filters.receiver.length > 0) {
      filters.receiverText = ""
    }
    onFilter(filters);
    setIsDrawerOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" flexDirection="column" gap={2} width="100%">
        {/* Sender */}
        <Autocomplete
          multiple
          freeSolo
          options={allSender}
          getOptionLabel={(option) =>
            `${option.firstname_TH} ${option.lastname_TH}`
          }
          value={filters.sender}
          onChange={(_, value) => handleChange("sender", value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="เลือกหรือกรอกชื่อผู้ส่ง "
              onChange={(e) => handleChange("senderText", e.target.value)}
              sx={{
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          )}
        />

        {/* Receiver */}
        <Autocomplete
          multiple
          freeSolo
          options={allReceiver}
          getOptionLabel={(option) =>
            `${option.firstname_TH} ${option.lastname_TH}`
          }
          value={filters.receiver}
          onChange={(_, value) => handleChange("receiver", value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="เลือกหรือกรอกชื่อผู้รับ"
              onChange={(e) => handleChange("receiverText", e.target.value)}
              sx={{
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          )}
        />

        {/* Driver */}
        <Autocomplete
          multiple
          freeSolo
          options={allDriver}
          getOptionLabel={(option) => option.FullName}
          value={filters.driver}
          onChange={(_, value) => handleChange("driver", value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="เลือกคนขับรถ"
              onChange={(e) => handleChange("driverText", e.target.value)}
              sx={{
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          )}
        />

        {/* Send Location */}
        <FormControl sx={{ borderRadius: 2, width: "100%" }}>
          <InputLabel>จุดรับของต้นทาง</InputLabel>
          <Select
            multiple
            value={filters.sendLocation}
            onChange={(e) => handleChange("sendLocation", e.target.value)}
            input={
              <OutlinedInput label="Send Location" sx={{ borderRadius: 2 }} />
            }
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((id) => {
                  const site = allSiteLocation.find((s) => s.idScgSite === id);
                  return site ? (
                    <Chip
                      key={id}
                      label={`Site ${site.noSite}: ${site.nameSite}`}
                    />
                  ) : null;
                })}
              </Box>
            )}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250,
                  overflowY: "auto",
                  mt: 1,
                },
              },
            }}
          >
            {allSiteLocation.map((site) => (
              <MenuItem key={site.idScgSite} value={site.idScgSite}>
                Site {site.noSite}: {site.nameSite}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Receive Location */}
        <FormControl sx={{ borderRadius: 2, width: "100%" }}>
          <InputLabel>จุดส่งของปลายทาง</InputLabel>
          <Select
            multiple
            value={filters.receiveLocation}
            onChange={(e) => handleChange("receiveLocation", e.target.value)}
            input={
              <OutlinedInput
                label="Receive Location"
                sx={{ borderRadius: 2 }}
              />
            }
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((id) => {
                  const site = allSiteLocation.find((s) => s.idScgSite === id);
                  return site ? (
                    <Chip
                      key={id}
                      label={`Site ${site.noSite}: ${site.nameSite}`}
                    />
                  ) : null;
                })}
              </Box>
            )}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250,
                  overflowY: "auto",
                  mt: 1,
                },
              },
            }}
          >
            {allSiteLocation.map((site) => (
              <MenuItem key={site.idScgSite} value={site.idScgSite}>
                Site {site.noSite}: {site.nameSite}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Start Date */}
        <DatePicker
          label="วันเริ่มต้น"
          value={filters.startDate}
          onChange={(date) => {
            handleChange("startDate", new Date(date));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          )}
        />

        {/* End Date */}
        <DatePicker
          label="วันสิ้นสุด"
          value={filters.endDate}
          onChange={(date) => {
            handleChange("endDate", new Date(date));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          )}
        />

        {/* Submit Button */}
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ borderRadius: 2 }}
          disabled={isButtonDisabled}
        >
          Apply Filters
        </Button>
      </Box>
    </LocalizationProvider>
  );
};

export default FilterDeliverySamplShuttle;
